import { useEffect } from 'react';

/**
 * Custom hook to set the document title dynamically
 * @param {string} pageTitle - The page-specific title (e.g., "Dashboard", "Clients")
 */
export const useDocumentTitle = (pageTitle) => {
  useEffect(() => {
    const baseTitle = 'PTC Client Hub';
    document.title = pageTitle ? `${pageTitle} | ${baseTitle}` : baseTitle;
    
    return () => {
      document.title = 'PTC Client Hub | Powered by Prestigious Companies';
    };
  }, [pageTitle]);
};

export default useDocumentTitle;
